import i18next from 'i18next';

import { reverseGeocode as reverseGeocodeViaEms } from '@ngsos/portal-core/incidents';
import { emsApi } from '@/api/emsApi';
import type { GeoPoint } from '@/signalr/contracts';

function currentTwoLetterLanguage(): string {
  const language = i18next.language || 'en';
  return language.split('-')[0] ?? 'en';
}

export function reverseGeocode(geoPoint: GeoPoint): Promise<string> {
  return reverseGeocodeViaEms(emsApi, geoPoint, currentTwoLetterLanguage());
}
